import React, { useEffect, createElement } from 'react';
import { NocheDeImpacto } from './pages/NocheDeImpacto';
const META_PIXEL_ID = '1288215226741477';
export function App() {
  useEffect(() => {
    // Initialize Facebook Pixel via script injection
    const f = window as any;
    if (f.fbq) return;
    const n = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    } as any;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    f.fbq = n;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', META_PIXEL_ID);
    f.fbq('track', 'PageView');
  }, []);
  return <NocheDeImpacto data-id="element-0" />;
}